export const en = {
    //naming convention: key is lowercase, spaces replaced by _
    language: 'English',
    keethings: 'Keethings',
    network_or_cors_error:'Cannot get data due to network or CORS error.',
    generic_error:'An error occurred, please try again or contact the support. [err: GENE]',
    cannot_get_or_send_data_from_server:'Cannot get/send data from/to the server. [err: FETCHE]',
    no_network_connection_available:'No network connection available. [err: OFFLINEE]',
    cannot_write_data_to_the_disk: 'Cannot write data to the disk. [err: DATAWRT]',
    data_did_not_pass_validation: 'Data did not pass validation. [err: VALERR]',
    missing_plugin:'Missing plugin [err: MISPLG]',
    resolve_file_system_location_error:'Resolve file system location error  [err: RESFS]',
    error_writing_file_or_directory:'Error writing file or directory  [err: FSWRT]',
    misconfiguration_error:'Misconfiguration error [err: MISCONF]'
};

//only on "en" file.
export type Translation = typeof en;